(()=>{const mobile=()=>innerWidth<=749;
const galleryOrigins=new WeakMap();
function gallery(){document.querySelectorAll('.product__media-gallery').forEach(g=>{let t=g.querySelector('.thumbnail-slider'),media=g.querySelector('.product__media-list')?.parentElement,next=g.querySelector('.zn-gallery-arrow--next'),previous=g.querySelector('.zn-gallery-arrow--previous');if(!t||!media)return;if(!galleryOrigins.has(g))galleryOrigins.set(g,[t,previous,next].filter(Boolean).map(node=>({node,parent:node.parentElement,after:node.nextSibling})));if(innerWidth>991){galleryOrigins.get(g).slice().reverse().forEach(({node,parent,after})=>{if(node.parentElement!==parent||node.nextSibling!==after){if(after&&after.parentNode===parent)parent.insertBefore(node,after);else if(node.parentNode!==parent)parent.append(node)}});return;}if(g.lastElementChild!==t)g.append(t);if(previous&&previous.parentElement!==t)t.append(previous);if(next&&next.parentElement!==t)t.append(next)})}
function state(r,p,n){if(!r||!mobile())return;let max=Math.max(0,r.scrollWidth-r.clientWidth),x=Math.max(0,r.scrollLeft);if(p)p.hidden=max<5||x<4;if(n)n.hidden=max<5||x>max-4}
function rail(r,p,n){if(!r||!mobile())return;let update=()=>state(r,p,n);if(p&&!p.dataset.zm){p.dataset.zm=1;p.onclick=e=>{e.preventDefault();r.scrollBy({left:-r.clientWidth*.72,behavior:'smooth'})}}if(n&&!n.dataset.zm){n.dataset.zm=1;n.onclick=e=>{e.preventDefault();r.scrollBy({left:r.clientWidth*.72,behavior:'smooth'})}}if(!r.dataset.zm){r.dataset.zm=1;r.addEventListener('scroll',update,{passive:true})}update();setTimeout(update,300)}
function home(){if(!mobile())return;document.querySelectorAll('.zf-rail-wrap').forEach(w=>rail(w.querySelector('[data-zf-rail="love"]'),w.querySelector('[data-zf-prev]'),w.querySelector('[data-zf-next]')));document.querySelectorAll('.zf-featured').forEach(w=>rail(w.querySelector('[data-zf-rail="featured"]'),w.querySelector('[data-zf-featured-prev]'),w.querySelector('[data-zf-featured-next]')))}
let queued=false;function boot(){queued=false;gallery();if(!mobile())return;home()}function schedule(){if(!queued){queued=true;requestAnimationFrame(boot)}}addEventListener('load',boot);addEventListener('resize',schedule,{passive:true});document.addEventListener('shopify:section:load',boot);new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});boot()})();

/* ZELTRON SHOP BY + MOBILE GALLERY V2 */
(() => {
  const mobile = () => window.matchMedia('(max-width: 749px)').matches;

  function initialiseGallery(gallery) {
    if (!mobile() || gallery.dataset.znSwipeReady === 'true') return;

    const viewer = gallery.querySelector('slider-component:has(.product__media-list)');
    const rail = gallery.querySelector('.product__media-list');
    const navigation = viewer?.querySelector('.slider-buttons');
    const previous = navigation?.querySelector('.slider-button--prev');
    const next = navigation?.querySelector('.slider-button--next');
    const current = navigation?.querySelector('.slider-counter--current');
    const total = navigation?.querySelector('.slider-counter--total');

    if (!viewer || !rail || !navigation || !previous || !next) return;

    gallery.dataset.znSwipeReady = 'true';
    navigation.classList.add('zn-mobile-gallery-nav');

    const update = () => {
      const index = Number.parseInt(current?.textContent || '1', 10);
      const count = Number.parseInt(total?.textContent || '1', 10);
      previous.classList.toggle('zn-is-hidden', index <= 1);
      next.classList.toggle('zn-is-hidden', count <= 1 || index >= count);
    };

    let startX = 0;
    let startY = 0;
    let tracking = false;

    rail.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      tracking = true;
    }, { passive: true });

    rail.addEventListener('touchend', (event) => {
      if (!tracking || !event.changedTouches[0]) return;
      tracking = false;
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      if (deltaX < 0) next.click();
      else previous.click();
      window.setTimeout(update, 350);
    }, { passive: true });

    navigation.addEventListener('click', () => window.setTimeout(update, 80));
    if (current) new MutationObserver(update).observe(current, { childList: true, characterData: true, subtree: true });
    if (total) new MutationObserver(update).observe(total, { childList: true, characterData: true, subtree: true });
    update();
  }

  function initialise() {
    document.querySelectorAll('.product__media-gallery').forEach(initialiseGallery);
  }

  document.addEventListener('DOMContentLoaded', initialise);
  document.addEventListener('shopify:section:load', initialise);
  new MutationObserver(initialise).observe(document.documentElement, { childList: true, subtree: true });
  initialise();
})();

/* ZELTRON SALE WHITE + FIGMA SHOP BY V2 */
(() => {
  function rebuildShopBy() {
    const details = document.querySelector('#Details-HeaderMenu-3');
    const menu = details?.querySelector(':scope > .header__mega_menu:not(.zn-care-dropdown)');
    const container = menu?.querySelector('.mega__menu--wrapper--column');
    const categoryList = container?.querySelector(':scope > .header__mega_menu--inner');
    const categories = categoryList ? [...categoryList.children].slice(0, 3) : [];
    const promos = container ? [...container.querySelectorAll(':scope > .mega__menu--promo')].slice(0, 3) : [];

    if (!container || container.querySelector('.zn-figma-shopby') || categories.length !== 3 || promos.length !== 3) return;

    const grid = document.createElement('div');
    grid.className = 'zn-figma-shopby';

    categories.forEach((category, index) => {
      const column = document.createElement('div');
      column.className = 'zn-figma-shopby__column';
      column.append(promos[index], category);
      grid.append(column);
    });

    const chargerTitle = categories[0].querySelector('.header__mega_menu_item');
    if (chargerTitle) chargerTitle.textContent = 'Charger Adapters';

    categoryList.remove();
    container.append(grid);
  }

  document.addEventListener('DOMContentLoaded', rebuildShopBy);
  document.addEventListener('shopify:section:load', rebuildShopBy);
  rebuildShopBy();
})();

;(() => {
  function lockFigmaSpacing() {
    document.querySelectorAll('#Details-HeaderMenu-3 .zn-figma-shopby .header__mega_sub_menu').forEach((list) => {
      list.style.setProperty('display', 'grid', 'important');
      list.style.setProperty('gap', '6px', 'important');
      list.style.setProperty('margin', '0', 'important');
      list.style.setProperty('padding', '0', 'important');
    });
  }
  document.addEventListener('DOMContentLoaded', lockFigmaSpacing);
  document.addEventListener('shopify:section:load', () => window.setTimeout(lockFigmaSpacing));
  lockFigmaSpacing();
})();

/* ZELTRON JUDGE.ME CAROUSEL POLISH — 20 Sep 2026 */
;(() => {
  function enhanceReviewCarousel() {
    if (!document.body.classList.contains('template-index')) return;

    document.querySelectorAll('.jdgm-carousel-wrapper').forEach((carousel) => {
      carousel.querySelectorAll('.jdgm-carousel-item__product').forEach((productLink) => {
        const title = productLink.querySelector('.jdgm-carousel-item__product-title');
        const productName = title?.textContent?.trim();

        if (productName && !productLink.getAttribute('aria-label')) {
          productLink.setAttribute('aria-label', `View ${productName}`);
        }
      });

      if (carousel.querySelector('.zn-view-all-reviews')) return;

      const button = document.createElement('a');
      const appReviewsLink = carousel.querySelector('.jdgm-carousel-title-and-link a[href]');
      button.className = 'zn-view-all-reviews';
      button.href = appReviewsLink?.href || '/pages/reviews';
      button.textContent = 'View All Reviews';
      button.setAttribute('aria-label', 'View all customer reviews');
      carousel.append(button);
    });
  }

  document.addEventListener('DOMContentLoaded', enhanceReviewCarousel);
  document.addEventListener('shopify:section:load', enhanceReviewCarousel);
  new MutationObserver(enhanceReviewCarousel).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  enhanceReviewCarousel();
})();

/* Keep product option labels visually consistent with the Quantity label. */
;(() => {
  function lockProductOptionLabelSize() {
    if (!document.body.classList.contains('template-product')) return;

    document.querySelectorAll('fieldset.product-form__input.radio--swatch > legend.form__label').forEach((label) => {
      label.style.setProperty('font-size', '16px', 'important');
      label.style.setProperty('font-weight', '700', 'important');
      label.style.setProperty('line-height', '1.2', 'important');

      label.querySelectorAll('strong, span').forEach((text) => {
        text.style.setProperty('font-size', '16px', 'important');
        text.style.setProperty('font-weight', '700', 'important');
        text.style.setProperty('line-height', '1.2', 'important');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', lockProductOptionLabelSize);
  document.addEventListener('shopify:section:load', lockProductOptionLabelSize);
  new MutationObserver(lockProductOptionLabelSize).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  lockProductOptionLabelSize();
})();

/* Make every visible review product image/title open its matching product. */
;(() => {
  const reviewRoots = '.jdgm-carousel-wrapper, .jdgm-all-reviews-page, .jm-review-widget, .jdgm-review-widget';
  const reviewCards = '.jdgm-carousel-item, .jdgm-rev, .jm-review-item, [class*="review-item"]';
  const productMedia = '.jdgm-carousel-item__product-image, .jm-review-widget-header__product-image, [class*="product-image"]';
  const productUrlCache = new Map();

  function getProductUrl(productName) {
    const cacheKey = productName.toLowerCase();
    if (productUrlCache.has(cacheKey)) return productUrlCache.get(cacheKey);

    const request = fetch(`${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(productName)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`, {
      headers: { Accept: 'application/json' }
    })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {
        const products = data?.resources?.results?.products || [];
        const exactProduct = products.find((product) => product.title?.trim().toLowerCase() === cacheKey);
        return exactProduct?.url || products[0]?.url || '';
      })
      .catch(() => '');

    productUrlCache.set(cacheKey, request);
    return request;
  }

  async function linkReviewCard(card) {
    let productLink = card.querySelector(
      'a.jdgm-carousel-item__product[href], .jdgm-carousel-item__product a[href], a[href*="/products/"]'
    );
    const productContainer = card.querySelector('.jdgm-carousel-item__product, [class*="review-product"]');
    const existingTitle = card.querySelector('.jdgm-carousel-item__product-title, [class*="product-title"]');
    const productImage = card.querySelector(`${productMedia} img, img.jdgm-carousel-item__product-image, img[class*="product-image"]`);
    const productSlug = productLink?.pathname?.split('/products/')[1]?.split(/[?#/]/)[0] || '';
    const slugTitle = productSlug
      ? decodeURIComponent(productSlug).replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase())
      : '';
    const productName = existingTitle?.textContent?.trim()
      || productImage?.alt?.trim()
      || productLink?.getAttribute('title')?.trim()
      || productLink?.getAttribute('aria-label')?.replace(/^view\s+/i, '').trim()
      || card.dataset.productTitle?.trim()
      || slugTitle;

    if (!productName) return;

    if (!productLink) {
      if (!productContainer || productContainer.dataset.znLinkPending === 'true') return;
      productContainer.dataset.znLinkPending = 'true';

      const productUrl = await getProductUrl(productName);
      if (!productUrl) {
        delete productContainer.dataset.znLinkPending;
        return;
      }

      productLink = document.createElement('a');
      productLink.href = productUrl;
      productLink.className = 'zn-review-product-link';
      while (productContainer.firstChild) productLink.append(productContainer.firstChild);
      productContainer.append(productLink);
    } else {
      productLink.classList.add('zn-review-product-link');
    }

    if (!productLink.querySelector('.zn-review-product-link-label')) {
      const label = document.createElement('span');
      label.className = 'zn-review-product-link-label';
      label.textContent = productName;
      productLink.append(label);
    }

    productLink.setAttribute('aria-label', `View ${productName}`);
  }

  function linkReviewProducts(root = document) {
    const widgets = [];
    if (root.matches?.(reviewRoots)) widgets.push(root);
    widgets.push(...root.querySelectorAll(reviewRoots));
    widgets.forEach((widget) => {
      widget.querySelectorAll(reviewCards).forEach((card) => void linkReviewCard(card));
    });
  }

  document.addEventListener('click', (event) => {
    const media = event.target.closest('[data-zn-product-url]');
    if (media) window.location.assign(media.dataset.znProductUrl);
  });

  document.addEventListener('keydown', (event) => {
    const media = event.target.closest('[data-zn-product-url]');
    if (media && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      window.location.assign(media.dataset.znProductUrl);
    }
  });

  document.addEventListener('DOMContentLoaded', () => linkReviewProducts());
  document.addEventListener('shopify:section:load', (event) => linkReviewProducts(event.target));
  new MutationObserver(() => linkReviewProducts()).observe(document.documentElement, { childList: true, subtree: true });
  linkReviewProducts();
})();
